import React from 'react';
import { Send } from 'react-feather';
import { List } from '../../core/List';
import { Card } from '../../core/Card';
import { ApiDataAccess } from '../../infrastructure/ApiDataAccess';

export const StalePendingTransmissionSkus = () => {
    var dataAccess = new ApiDataAccess('/api/notify');

    const sendSkus = async (orderNumber) => {
        await dataAccess.post(`/order/${orderNumber}`);
        window.location.reload();
    };

    return (
        <Card title="Health" subtitle="Stale Pending Transmission Skus">
            <div className="skus-health">
                <List
                    controller="api/esko/health/sku/"
                    action="stale-pending-transmission-skus"
                    headers={[
                        { column: 'orderNumber', title: 'Order Number', sortable: true },
                        { column: 'send', title: 'Send', sortable: false },
                    ]}
                    onRenderRow={(column, item, header) => {
                        switch (column) {
                            case 'send':
                                return (
                                    <span title="Send">
                                        <Send onClick={() => sendSkus(item)} />
                                    </span>
                                );
                            default:
                                return <span>{item}&nbsp;</span>;
                        }
                    }}
                />
            </div>
        </Card>
    );
};